"use client"

import { useEffect } from "react"
import { useTheme } from "next-themes"

export function ThemeInitializer() {
    const { setTheme } = useTheme()

    useEffect(() => {
        // Default theme: if the user has no stored preference, use dsat-school for light-OS users
        const storedTheme = localStorage.getItem("theme")
        if (!storedTheme || storedTheme === "system") {
            const prefersLight = window.matchMedia("(prefers-color-scheme: light)").matches
            if (prefersLight) {
                setTheme("dsat-school")
            }
        }
    }, [setTheme])

    return null
}
